// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".close-toast[data-v-fafcc372]{background-color:transparent;line-height:1;margin-right:-.5rem;margin-top:-.5rem}.close-toast .icon-clear[data-v-fafcc372]{font-size:1rem}.b-toast[data-v-fafcc372]{left:0;margin:0 auto;max-width:300px;position:absolute;right:0;top:1rem;z-index:1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
